export const EMPLOYEE_STATES = [
  'ca',
]

// for non specified state
export const EMPLOYEE_FEDERAL = 'federal';
